<template>
  <v-container  class="mx-2">
    <v-row>
      <v-col cols="12" lg="7">
        <v-breadcrumbs class="pl-0 pt-0" :items="items" />
        <h1 class="mb-2">Новый Абонент</h1>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-row>
            <v-col cols="12" sm="6">
              <v-text-field
                v-model='phoneNumber'
                label="телефон"
                prepend-inner-icon="mdi-phone"
                outlined
                dense
                hide-details
                flat
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6">
              <v-text-field
                v-if ="doorphone"
                type="number"
                v-model='apartment'
                label="квартира"
                prepend-inner-icon="mdi-counter"
                :rules="[
                  v => !!v || 'Поле обязательно для заполнения',
                  v => ( v && v >= minApartment && v <= maxApartment) || 'Диапазон квартир: ' + minApartment + ' - ' + maxApartment,
                ]"
                outlined
                dense
                flat
                required
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="6">
              <v-checkbox
                v-model='keyDuplicate'
                v-if ="doorphone"
                label="дублировать абонента в доп.вход"
                outlined
                dense
                hide-details
                class="checkbox ma-0 checkbox-direction"
                flat
              ></v-checkbox>
            </v-col>
          </v-row>

          <v-row class="pl-3 pr-3">
            <v-btn
              @click="popupDoorphones.bind = true"
              class="mr-3"
              color="#1E6CEB"
              dark
              v-if ="!doorphone && !key"
            >
              Привязать домофон
            </v-btn>
            <v-btn
              @click="popupKeys.bind = true"
              class="mr-3"
              color="#1E6CEB"
              dark
              v-if ="doorphone && !key"
            >
              Добавить ключ
            </v-btn>
          </v-row>

          <v-card-actions class="pl-0">
            <div class="my-2">
              <v-btn
                @click.prevent="submit"
                :disabled="!valid"
                large
                color="success"
                class="text-none"
                dense
              >
                Сохранить
              </v-btn>
              <v-btn
                @click.prevent="returnResidentAccounts()"
                large
                class="ma-2 text-none"
                outlined
                dense
                hide-details color="error"
              >
                Отменить
              </v-btn>
            </div>
          </v-card-actions>
        </v-form>
      </v-col>
    </v-row>

    <v-card class="px-5 pb-5" v-if ="doorphone" fluid>
      <v-card-text>
        <v-row align="center">
          <v-col cols="8" class="doorphone-text">
            <b>Домофон:</b>{{ getDoorphoneAddress(doorphone) }}
          </v-col>
          <v-col cols="4">
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="#1E6CEB"
                dark
                right
                @click.prevent="doorphone = null"
              >
                <span class="icon-multiply"></span>
              </v-btn>
            </v-card-actions>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card class="px-5 pb-5" v-if ="key" fluid>
      <v-card-text>
        <v-row align="center">
          <v-col cols="8" class="key-text">
            <b>Ключ:</b> {{key.code}}
          </v-col>
          <v-col cols="4">
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="#1E6CEB"
                dark
                right
                @click.prevent="key = null"
              >
                <span class="icon-multiply"></span>
              </v-btn>
            </v-card-actions>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-dialog
      v-model="popupDoorphones.bind"
      max-width="650"
      lazy-validation
    >
      <v-card class='pb-5'>
        <v-progress-linear v-if="loading" indeterminate color="primary"></v-progress-linear>
        <v-card-title class="headline">Привязать домофон</v-card-title>
        <v-row class="mx-6 mt-2">
          <v-text-field
            v-model='popupDoorphones.filterAddress'
            placeholder="Поиск по адресу"
            class="mr-2"
            solo
            outlined
            dense
            hide-details
            flat
          ></v-text-field>
          <v-text-field
            v-model='popupDoorphones.filterId'
            placeholder="Поиск по id"
            solo
            outlined
            dense
            hide-details
            flat
          ></v-text-field>
        </v-row>
        <div class="ml-6 mt-3">
          <v-btn
            dark
            class="btn blue darken-3 white px-7 text-none mt-2 mb-4"
            @click.prevent="filterDoorphones"
          >
            Поиск
          </v-btn>
        </div>
        <v-data-table
          class="table mx-5 pb-5"
          :options.sync="options"
          :server-items-length="totalDoorphones"
          :items="searchFreeDoorphones"
          :headers="headersTieDoorphones"
          :footer-props="{
            'items-per-page-options': [10, 20, 50, 100],
          }"
        >
          <template v-slot:item.address="{ item }">
            {{ getDoorphoneAddress(item) }}
          </template>
          <template v-slot:item.actions="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="on"
                  text
                  x-large
                  class="btn__icon pa-0"
                  width="18"
                  height="18"
                  @click.prevent="addDoorphone(item)"
                >
                  <v-icon color="blue">mdi-plus-circle</v-icon>
                </v-btn>
              </template>
              <span>Привязать домофон</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="popupKeys.bind"
      max-width="650"
      lazy-validation
    >
      <v-card class='pb-5'>
        <v-card-title class="headline">Добавить ключ</v-card-title>
        <v-col class="px-5 pb-5">
          <v-text-field
            v-model='popupKeys.serchValue'
            placeholder="Поиск по коду"
            solo
            outlined
            dense
            hide-details
            flat
          ></v-text-field>
        </v-col>
        <v-data-table
          class="table mx-5 pb-5"
          :headers="headersFreeKeys"
          :items="searchFreeKeys"
          :server-items-length="totalKeys"
          :options.sync="optionsKeys"
          :items-per-page="10"
          :footer-props="{
            'items-per-page-options': [ 5, 10, 20],
          }"
        >
          <template  v-slot:item.actions="{ item }">
            <v-row align="center">
              <v-col cols=12>
                <v-row justify="center">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        v-bind="attrs"
                        v-on="on"
                        text
                        x-large
                        class="btn__icon pa-0"
                        width="18"
                        height="18"
                        @click.prevent="addKey(item)"
                      >
                        <v-icon color="blue">mdi-plus-circle</v-icon>
                      </v-btn>
                    </template>
                    <span>Добавить ключ</span>
                  </v-tooltip>
                </v-row>
              </v-col>
            </v-row>
          </template>
        </v-data-table>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { DEFAULT_DATA_TABLE_OPTIONS } from '@/constants/data-table';
import watchTableOptions from '../../mixins/watchTableOptions';

export default {
  name: 'ResidentAccountNew',
  mixins: [watchTableOptions],
  props: ['id'],
  data () {
    return {
      items: [
        {
          text: 'Список клиентов',
          disabled: false,
          href: '/list-cliens',
        },
        {
          text: 'Новый Абонент',
          disabled: true,
          href: '#',
        },
      ],
      valid: true,
      usedDoorphones: [],
      minApartment: 1,
      maxApartment: 100000,
      apartment: '',
      phoneNumber: '',
      totalDoorphones: 0,
      isCreated: false,
      loading: true,
      keyDuplicate: '',
      totalKeys: '',
      filters: { type: 'A,M,G' },
      doorphone: null,
      key: null,
      optionsKeys: DEFAULT_DATA_TABLE_OPTIONS,
      options: {
        sortBy: [],
        sortDesc: [],
        page: 1,
        itemsPerPage: 10,
      },
      popupDoorphones: {
        bind: false,
        confirm: false,
        value: '',
        filterAddress: '',
        filterId: '',
      },
      popupKeys: {
        bind: false,
        confirms: false,
        value: '',
        serchValue: '',
      },
      headersTieDoorphones: [
        { text: 'id', value: 'id', sortable: false },
        { text: 'Адрес', value: 'address', sortable: false },
        { text: '', value: 'actions', sortable: false },
      ],
      headersFreeKeys: [
        { text: 'id', value: 'id', sortable: false },
        { text: 'Код', value: 'code', sortable: false },
        { text: '', value: 'actions', sortable: false },
      ],
    };
  },
  watch: {
    options: {
      handler () {
        if (!this.isCreated) {
          this.updateSort();
          this.loadDoorphones();
        } else {
          this.isCreated = false;
        }
      },
      deep: true,
    },
    optionsKeys (curr, prev) {
      this.handleOptionsChange(curr, prev, () => {
        this.getAllKeys();
      });
    },
  },
  created () {
    this.loadClient({
      id: this.$route.params.id,
      options: {
        include: ['abonents.doorphones'],
      },
    })
      .then(() => {
        this.phoneNumber = this.client.telephone;
        if (this.client.abonents) {
          this.client.abonents.forEach((abonent) => {
            if (abonent.doorphones.length > 0) {
              abonent.doorphones.forEach((doorphone) => {
                this.usedDoorphones.push(doorphone.id);
              });
            }
          });
        }
      });
  },
  computed: {
    ...mapGetters({
      doorphones: 'Doorphone/doorphonesExpanded',
      keys: 'Keys/keys',
      client: 'Client/client',
    }),
    searchFreeDoorphones () {
      let freeDoorphones = this.doorphones;

      if (this.popupDoorphones.serchValue) {
        freeDoorphones = freeDoorphones.filter(item => {
          return item.address.toString().toLowerCase().includes(this.popupDoorphones.serchValue.toLowerCase());
        });
      }

      if (this.popupDoorphones.serchValueId) {
        freeDoorphones = freeDoorphones.filter(item => {
          return item.id.toString().toLowerCase().includes(this.popupDoorphones.serchValueId.toLowerCase());
        });
      }

      return freeDoorphones.filter(item => {
        return !this.usedDoorphones.includes(item.id);
      });
    },
    searchFreeKeys () {
      if (this.popupKeys.serchValue) {
        return this.keys.filter(item => {
          return item.code.toString().toLowerCase().includes(this.popupKeys.serchValue.toLowerCase());
        });
      }
      return this.keys;
    },
  },
  methods: {
    ...mapActions({
      abonentsCreateByPhone: 'Abonents/abonentsCreateByPhone',
      getDoorphones: 'Doorphone/getDoorphones',
      getExpandedDoorphones: 'Doorphone/getExpandedDoorphones',
      loadClient: 'Client/loadClient',
      addClientAbonent: 'Client/addClientAbonent',
      getKeys: 'Keys/getKeys',
    }),
    validateKeyUp (e) {
      if (e.keyCode === 13) {
        this.filterDoorphones();
      }
    },
    getDoorphoneAddress (doorphone) {
      let address = doorphone.address;
      if (doorphone.type === 'G') {
        address += ', (калитка)';
      }
      if (doorphone.entrance > 0) {
        address = `${doorphone.address}, п.${doorphone.entrance}`;
        if (doorphone.type === 'A') {
          address += ', (доп.вход)';
        }
      }
      return address;
    },
    updateSort () {
      if (this.options.sortBy.length > 0) {
        if ((this.options.sortDesc.length > 0) && (this.options.sortDesc[0])) {
          this.sort = '-' + this.options.sortBy[0];
        } else {
          this.sort = this.options.sortBy[0];
        }
      } else {
        this.sort = '';
      }
    },
    loadDoorphones () {
      this.getExpandedDoorphones({
        pagination: 1,
        page: this.options.page,
        limit: this.options.itemsPerPage,
        sort: this.sort,
        filters: this.filters,
      })
        .then((data) => {
          this.loading = false;
          this.totalDoorphones = data.meta.total;
        });
    },
    filterDoorphones () {
      this.options.page = 1;
      this.filters = { type: 'A,M,G' };

      if (this.popupDoorphones.filterAddress) {
        this.filters.address = this.popupDoorphones.filterAddress;
      }
      if (this.popupDoorphones.filterId) {
        this.filters.id = this.popupDoorphones.filterId;
      }
      this.$router.push({
        query: {
          address: this.filters.address,
        },
      }).catch(() => {});
      this.loadDoorphones();
    },
    createNewAccount () {
      if (!this.doorphone) {
        this.$flash_warning('Привяжите домофон');
      }
      if (!this.key) {
        this.$flash_warning('Привяжите ключ');
      } else {
        let dataAbonent = {};
        dataAbonent = {
          apartment: this.apartment,
          keys: [this.key.id],
          doorphone_id: this.doorphone.id,
          telephone: this.phoneNumber,
          duplicate: +this.keyDuplicate,
        };
        this.abonentsCreateByPhone(dataAbonent)
          .then((res) => {
            this.addClientAbonent({
              clientId: this.$route.params.id,
              abonentId: res.data.abonent.id,
            })
              .then(() => {
                this.$router.push({ name: 'ListClients' });
                this.$flash_success('Абонент успешно создан и привязан');
              });
          })
          .catch((err) => {
            if (err.message.includes('422')) {
              const response = err.response.data;
              for (const input in response) {
                response[input].forEach(error => this.$flash_warning(input + ': ' + error));
              }
            } else {
              this.$flash_warning('Ошибка при привязке нового абонента');
            }
          });
      }
    },

    submit () {
      this.validate();
      this.$nextTick(function () {
        if (this.valid) {
          this.createNewAccount();
        }
      });
    },

    validate () {
      this.$refs.form.validate();
    },

    returnResidentAccounts () {
      this.$router.push({ name: 'DetailClient', params: { id: this.$route.params.id } });
    },

    addDoorphone (doorphone) {
      if (doorphone.diapason_from) {
        this.minApartment = doorphone.diapason_from;
        this.maxApartment = doorphone.diapason_to;
        this.validate();
        this.doorphone = doorphone;
        this.cancelBindDoorphone();
        this.getAllKeys();
      } else {
        this.$flash_danger('У домофона нет диапазона квартир');
      }
    },

    getAllKeys () {
      this.getKeys({
        pagination: 1,
        page: this.optionsKeys.page,
        limit: this.optionsKeys.itemsPerPage,
        filters: {
          // временное решение
          // doorphone_id: this.doorphone.id,
          // abonent_id: null,
          universal: 0,
        },
        include: ['abonent'],
      })
        .then((response) => {
          this.totalKeys = response.meta.total;
        })
        .catch((error) => {
          console.error(error);
          this.$sentry_exception(error);
          this.$flash_warning('Ошибка при загрузке ключей домофона');
        });
    },

    addKey (key) {
      this.key = key;
      this.cancelBindDoorphone();
    },

    cancelBindDoorphone () {
      this.popupDoorphones.confirm = false;
      this.popupDoorphones.bind = false;
      this.popupKeys.confirms = false;
      this.popupKeys.bind = false;
      this.popupKeys.value = '';
      this.popupDoorphones.value = '';
      this.popupDoorphones.serchValue = '';
      this.popupDoorphones.serchValueId = '';
    },
  },
};
</script>

<style>
.key-text, .doorphone-text {
  font-size: 21px;
  font-weight: 400;
}
.checkbox {
  border: 1px solid rgba(158, 158, 158, 1);
  border-radius: 4px;
  padding: 7px;
}
</style>
